import { render, staticRenderFns } from "./CardModalComponent.vue?vue&type=template&id=395347c3&scoped=true&"
import script from "./CardModalComponent.vue?vue&type=script&lang=js&"
export * from "./CardModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./CardModalComponent.vue?vue&type=style&index=0&id=395347c3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395347c3",
  null
  
)

export default component.exports